function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import withSocialCard from './SocialCard';
import { ValueProp, PostBody, MerchantInfo, AdminDate } from './SocialCardStyles';
import { Link } from 'react-router-dom';
import moment from 'moment';
import lazySizes from 'lazysizes';

var Card = function (_Component) {
  _inherits(Card, _Component);

  function Card() {
    _classCallCheck(this, Card);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  Card.prototype.render = function render() {
    var _props = this.props,
        merchant = _props.merchant,
        profile = _props.profile,
        image = _props.image,
        post = _props.post,
        admin = _props.admin,
        deal = _props.deal,
        schedule = _props.schedule,
        subscriber = _props.subscriber;


    if (!deal) return null;

    return React.createElement(
      'div',
      null,
      admin && moment(schedule.get('start_date')).isAfter() && React.createElement(
        AdminDate,
        null,
        React.createElement(
          'strong',
          null,
          'NOT LIVE'
        ),
        React.createElement('br', null),
        'STARTS:',
        ' ',
        moment(schedule.get('start_date')).format('ddd, MMM Do YYYY')
      ),
      !admin && React.createElement(
        ValueProp,
        {
          onClick: !deal.soldOut ? this.props._customer.addItemToCart.bind(this, deal) : null },
        !deal.soldOut ? 'Buy Now' : 'SOLD OUT'
      ),
      React.createElement(
        'header',
        { className: 'mb-1' },
        React.createElement(
          PostBody,
          null,
          'Pay ',
          '$',
          deal.get('paid_amount') / 100,
          ' for ',
          '$',
          deal.get('value_amount') / 100
        ),
        deal.donation > 0 && React.createElement(
          'p',
          null,
          '$',
          deal.donation,
          ' ',
          ' of your purchase will be donated to ',
          deal.recipient
        )
      ),
      merchant && React.createElement(MerchantInfo, { profile: profile, merchant: merchant })
    );
  };

  return Card;
}(Component);

export var DealCard = withSocialCard(Card);


//////////////////
// WEBPACK FOOTER
// ../ui-components/es/social/DealCard.js
// module id = 775
// module chunks = 4